import React from "react";
import Testimonial from "../../../components/v2/mw-carousel/testimonial";
import AgentIntegration from "../../../components/v2/agent-integration";
import Accordion from "../../../components/v2/accordion/accordion";
import ProductResources from "../../../components/v2/product/product-resource";
import ProductHeroSection from "../../../components/v2/common/product-hero";
import FeaturesMonitoring from "../../../components/v2/tabs/features-monitoring";
import ProductTour from "../../../components/v2/product/product-tour";
import {Docker, K8s, Linux, Windows} from "../../../components/v2/icons";
import { useTranslation } from "next-i18next";
import '../../../styles/scss/_faq-section.module.scss';

export default function RumErrorTracking() {

    const { t } = useTranslation("common", { keyPrefix: "product.rum-error-tracking" });

    const heroTitle = (
        <h1>
            <span className={"text-gradient"}>{t("hero.highlight")}</span>
            {t("hero.title")}
        </h1>
    );

    const featuresTitle = (
        <h2>
            <span className={"text-gradient"}>{t("featuresSection.highlight")}</span>
            {t("featuresSection.suffix")}
        </h2>
    );

    const features = [
        {
            id: "browser-errors",
            heading: t("features.browser.heading"),
            image: "/images/product/rum-browser-errors.png",
            title: t("features.browser.title"),
            list: [
                t("features.browser.list.0"),
                t("features.browser.list.1"),
                t("features.browser.list.2")
            ],
            imageAlt: t("features.browser.imageAlt")
        },
        {
            id: "troubleshooting",
            heading: t("features.troubleshooting.heading"),
            image: "/images/product/rum-error-troubleshooting.png",
            title: t("features.troubleshooting.title"),
            list: [
                t("features.troubleshooting.list.0"),
                t("features.troubleshooting.list.1"),
                t("features.troubleshooting.list.2")
            ],
            imageAlt: t("features.troubleshooting.imageAlt")
        },
        {
            id: "alerts",
            heading: t("features.alerts.heading"),
            image: "/images/product/error-track-alerting.png",
            title: t("features.alerts.title"),
            list: [
                t("features.alerts.list.0"),
                t("features.alerts.list.1"),
                t("features.alerts.list.2")
            ],
            imageAlt: t("features.alerts.imageAlt")
        }
    ]

    const resource = [
        {
            category: t("resources.items.0.category"),
            title: t("resources.items.0.title"),
            link: "/blog/kubernetes-common-errors-fix/"
        },
        {
            category: t("resources.items.1.category"),
            title: t("resources.items.1.title"),
            link: "/blog/github-commit-ownership-error-tracking/"
        },
    ]

    const faqs = [
        {
            id: 1,
            header: t("faq.items.0.question"),
            text: <p>{t("faq.items.0.answer")}</p>
        },
        {
            id: 2,
            header: t("faq.items.1.question"),
            text: <p>{t("faq.items.1.answer")}</p>
        },
        {
            id: 3,
            header: t("faq.items.2.question"),
            text: <p>{t("faq.items.2.answer")}</p>
        },
        {
            id: 4,
            header: t("faq.items.3.question"),
            text: <p>{t("faq.items.3.answer")}</p>
        },
        {
            id: 5,
            header: t("faq.items.4.question"),
            text: <p>{t("faq.items.4.answer")}</p>
        },
        {
            id: 6,
            header: t("faq.items.5.question"),
            text: <p>{t("faq.items.5.answer")}</p>
        }
    ];

    const agentDeployData = t("product.shared.agentDeploy", { returnObjects: true }) as any[];
    const agentDeployArray = Array.isArray(agentDeployData) ? agentDeployData : [];
    const agentDeploy = agentDeployArray.map(agent => ({
        ...agent,
        icon: agent.key === 'kubernetes' ? <K8s/> :
              agent.key === 'linux' ? <Linux/> :
              agent.key === 'docker' ? <Docker/> :
              agent.key === 'windows' ? <Windows/> :
              <span className={"text-gradient"}>450+</span>
    }))

    return (
        <>
            <ProductHeroSection title={heroTitle}
                                description={t("hero.description")}
                                img={"/images/product/rum-error-tracking.png"} imgMobile={"/images/product/rum-error-tracking-mobile.webp"} imgAlt={t("hero.imageAlt")} preloadImg hasActions={true} className={"rum-monitoring"}/>


            <FeaturesMonitoring productFeatures={features} title={featuresTitle} tourId={"rum-error-tracking"}/>

            <Testimonial/>

            <ProductTour tourSrc={"https://app.supademo.com/embed/clzmrrt6s003abk4joqg10h5v?embed_v=2"} title={t("tour.title")} tourId={"rum-error-tracking"} description={t("tour.description")}/>

            <AgentIntegration agentDeploy={agentDeploy}/>

            <ProductResources resources={resource} title={t("resources.title")}/>

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{t("faq.title")}</h2>
                    <p>{t("faq.description")}</p>
                    <div className={"faq-item"}>
                        <Accordion faqs={faqs} showGroups={true}/>
                    </div>
                </div>
            </section>

        </>
    )
}